import React, { useEffect, useState } from "react";
import {
    Layout,
    Button,
    Row,
    Typography,
    Card,
    Select,
    Form,
    Col,
    Table,
    Input,
    Popconfirm,
    Space,
} from "antd";
import { FilterOutlined, PlusOutlined, CloseCircleFilled } from "@ant-design/icons"
import TextArea from "antd/es/input/TextArea";
import CustomButton from "../../../../components/custom/CustomButton";


const { Text } = Typography;


const RenderedFields = ({ fields, remove, inputName, formValues }) => {
    return (
        <>
            {fields.map(({ key, name, ...restField }) => (
                <Space
                    key={key}
                    style={{
                        display: 'flex',
                        marginBottom: 8,
                    }}
                >
                    <Form.Item
                        {...restField}
                        name={[name, 'text2']}
                        label={<Text strong>Text</Text>}
                        rules={[{
                            required: true,
                            message: "Required Field"
                        }]}
                    >
                        <Input
                            placeholder="xxxxxxxx"
                            style={{ width: "30vh" }}
                        />
                    </Form.Item>

                    <Form.Item
                        {...restField}
                        name={[name, 'value']}
                        label={<Text strong>Value</Text>}
                        rules={[{
                            required: true,
                            message: "Required Field"
                        }]}
                        style={{marginLeft: 40}}>
                        <Input
                            placeholder="xxxxxxxx"
                            style={{ width: "30vh"}}
                        />
                    </Form.Item>

                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => remove(name)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: '#15CCAE',
                                color: 'white',
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                    >
                        <CloseCircleFilled height={2} width={2} style={{
                            color: "#92428B", fontSize: "25px", fontWeight: "bolder", marginTop: 10
                        }} />
                    </Popconfirm>
                </Space>
            ))}
        </>
    )
}

export const QuestionsForm = ({handleOnProceedClick}) => {

    const [addOptions, setAddOptions] = useState(false);
    const [formData, setFormData] = useState(null);


    const onFinishForm = (values) => {
        setFormData(values);
    }

    const handleValuesChange = (changedValues, allValues) => {
        setFormData(allValues)
    }

    const HandleOptionsClick = () => {
        setAddOptions(true)
    }

    const [form] = Form.useForm();



    return (
        <Card style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        }}
            title="Question"
        >
             <CloseCircleFilled height={2} width={2} style={{
                            color: "#92428B", 
                            fontSize: "25px", 
                            fontWeight: "bolder", 
                            marginTop: 10,
                            position: "absolute", 
                            top: 5,
                            right: 20,
                        }} 
                        onClick={handleOnProceedClick}/>
                        
            <Row style={{ justifyContent: "space-between" }}>

                <Col span={8}>
                    <Form.Item
                        name="key2"
                        label={<Text strong>Key</Text>}
                        rules={[{
                            required: true,
                            message: "Required Field"
                        }]}
                    >
                        <Input
                            placeholder="xxxxxxxx"
                            style={{ width: "30vh" }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="text1"
                        label={<Text strong>Text</Text>}
                        rules={[{
                            required: true,
                            message: "Required Field"
                        }]}>
                        <Input
                            placeholder="xxxxxxxx"
                            style={{ width: "30vh" }}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row style={{ justifyContent: "space-between" }}>

                <Col span={8}>
                    <Form.Item
                        name="description"
                        label={<Text strong>Description</Text>}>
                        <TextArea
                            placeholder="Enter description"
                            style={{ width: "45vh", height: "15vh" }}
                        />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <div style={{ width: "30vh" }}></div>
                </Col>
            </Row>

            <Form.List name="addOptions">
                {(fields, { add, remove }) => (
                    <>
                        <Button
                            onClick={() => add()}
                            type="primary"
                            icon={<PlusOutlined />}
                            style={{ backgroundColor: "#15CCAE", color: "white", width: "15vh", marginBottom: 20 }}
                        >Add Options</Button>
                        <RenderedFields
                            fields={fields}
                            add={add}
                            remove={remove}
                            inputName={"newCurrency"}
                            formValues={formData} />
                    </>
                )}
            </Form.List>

            {/* {addOptions &&
                <Row style={{justifyContent:"space-between"}}>
                    <Col span={8}>
                        <Form.Item
                            name="text2"
                            label={<Text strong>Text</Text>}
                            rules={[{
                                required: true,
                                message: "Required Field"
                            }]}
                        >
                            <Input
                                placeholder="xxxxxxxx"
                                style={{ width: "30vh" }}
                            />
                        </Form.Item>
                    </Col>


                    <Col span={8}>
                        <Form.Item
                            name="value"
                            label={<Text strong>Value</Text>}
                            rules={[{
                                required: true,
                                message: "Required Field"
                            }]}>
                            <Input
                                placeholder="xxxxxxxx"
                                style={{ width: "30vh" }}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={8}>

                    </Col>

                </Row>
                } */}
        </Card>
    );
}

